import { useState } from "react";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";

const usePost = (url) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const postData = async (payload , msg , errorMsg) => {
    setIsLoading(true);
    try {
      const response = await axios.post(url, payload);


      setData(response?.data); 
      toast.success(msg)
      setError(null); 
    } catch (err) {
      setError(err);
      toast.error(errorMsg || "There was an error. Please try again later.")
      setData(null); 
    } finally {
      setIsLoading(false); 
    }
  };

  return { isLoading, data, error, postData };
};

export default usePost;
